import {
    CREDIT_FACILITY_LABELS,
    CreditFacility,
} from "../../../api/credit_accounts";

export enum FacilityCategory {
    TERM_LOAN = "TERM_LOAN",
    WORKING_CAPITAL = "WORKING_CAPITAL",
    NON_FUND_BASED = "NON_FUND_BASED",
    OTHER = "OTHER",
}

export const creditFacilityClassificationMap: Record<
    CreditFacility,
    FacilityCategory
> = {
    [CreditFacility.TERM_LOAN]: FacilityCategory.TERM_LOAN,
    [CreditFacility.CASH_CREDIT]: FacilityCategory.WORKING_CAPITAL,
    [CreditFacility.OVERDRAFT]: FacilityCategory.WORKING_CAPITAL,
    [CreditFacility.DEMAND_LOAN]: FacilityCategory.WORKING_CAPITAL,
    [CreditFacility.BILLS_PURCHASED]: FacilityCategory.WORKING_CAPITAL,
    [CreditFacility.BILLS_DISCOUNTED]: FacilityCategory.WORKING_CAPITAL,
    [CreditFacility.PACKING_CREDIT]: FacilityCategory.WORKING_CAPITAL,
    [CreditFacility.BANK_GUARANTEE]: FacilityCategory.NON_FUND_BASED,
    [CreditFacility.LETTER_OF_CREDIT]: FacilityCategory.NON_FUND_BASED,
    [CreditFacility.LETTER_OF_UNDERTAKING]: FacilityCategory.NON_FUND_BASED,
    [CreditFacility.ACCEPTANCE]: FacilityCategory.NON_FUND_BASED,
    [CreditFacility.OTHERS]: FacilityCategory.OTHER,
};

export const FACILITY_CATEGORY_LABELS: Record<FacilityCategory, string> = {
    [FacilityCategory.TERM_LOAN]: "Term Loan",
    [FacilityCategory.WORKING_CAPITAL]: "Working Capital",
    [FacilityCategory.NON_FUND_BASED]: "Non Fund Based",
    [FacilityCategory.OTHER]: "Other",
};

export const CREDIT_FACILITY_TYPE_LABELS = CREDIT_FACILITY_LABELS;

export const CREDIT_FACILITY_SHORT_LABELS: Record<CreditFacility, string> = {
    [CreditFacility.TERM_LOAN]: "TL",
    [CreditFacility.CASH_CREDIT]: "CC",
    [CreditFacility.OVERDRAFT]: "OD",
    [CreditFacility.DEMAND_LOAN]: "DL",
    [CreditFacility.BILLS_PURCHASED]: "BP",
    [CreditFacility.BILLS_DISCOUNTED]: "BD",
    [CreditFacility.PACKING_CREDIT]: "PC",
    [CreditFacility.BANK_GUARANTEE]: "BG",
    [CreditFacility.LETTER_OF_CREDIT]: "LC",
    [CreditFacility.LETTER_OF_UNDERTAKING]: "LOU",
    [CreditFacility.ACCEPTANCE]: "ACC",
    [CreditFacility.OTHERS]: "OTH",
};

export const CREDIT_FACILITY_TYPE_OPTIONS = Object.values(CreditFacility).map(
    (value) => ({
      value,
      name: CREDIT_FACILITY_TYPE_LABELS[value],
    }),
);

export const FACILITY_CATEGORY_OPTIONS = Object.values(FacilityCategory).map(
    (value) => ({
      value,
      name: FACILITY_CATEGORY_LABELS[value],
    }),
);

export const getFacilityCategoryForCreditFacility = (
    creditFacility: CreditFacility,
) => creditFacilityClassificationMap[creditFacility];
